import { SubcontractsFilters } from './SCFilters';
import useParams from '../../../hooks/useParamsAndCookies';
import { URLParam } from '../../../Interfaces/system/params.interfaces';
import { parseDate, parseId } from '@/src/utils/param';

const params: URLParam<SubcontractsFilters>[] = [
  { label: 'reportType' },
  { label: 'job', isEncrypted: true },
  { label: 'subcontract', isEncrypted: true },
  { label: 'submittedID' },
  { label: 'info' },
  { label: 'jobs', isEncrypted: true, multiple: true },
  { label: 'subcontractor', isEncrypted: true, parse: parseId },
  { label: 'itemsState' },
  { label: 'dates', multiple: true, parse: parseDate },
];

const formatFilters = (filters: Partial<SubcontractsFilters>) => {
  return {
    ...filters,
    dates: filters.dates
      ? filters.dates.map((date) => date?.toString() || null)
      : null,
  };
};

const SCParams = () => {
  useParams<SubcontractsFilters>({
    tab: 'SC',
    params,
    formatFilters,
    filterChanges: (values) => {
      const cookies = values as {
        dates: (string | null)[];
      };
      const { dates, ...otherFields } = cookies;
      const newCookies = otherFields as Record<string, unknown>;

      if (dates) {
        const start = new Date(dates[0] ?? '');
        const end = dates[1] ? new Date(dates[1]) : null;
        newCookies['dates'] = [start, end];
      }

      return newCookies;
    },
    cookieFiltersName: 'filters',
  });

  return <span />;
};

export default SCParams;
